(() => {
  // get product recommendations
  const productRecommendationsSection = qs('.js-product-recommendation');
  let productRecommendationsId = productRecommendationsSection.dataset.productId;
  const productLimitShow = productRecommendationsSection.dataset.productLimit;
  const sectionIdentifier = productRecommendationsSection.dataset.sectionId;
  const breakpoint = window.matchMedia('(max-width: 768px)');

  fetch(
    window.Shopify.routes.root +
      `recommendations/products?product_id=${productRecommendationsId}&limit=${productLimitShow}&section_id=${sectionIdentifier}`
  )
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.js-product-recommendation');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        
        const sliders = qsa('.js-product-recommendation-swiper');
        const initSwiper = (
          init = false,
          slidesOffsetBefore = 100
        ) => {
          sliders && sliders.forEach((slider, index) => {
            const productRecommendation = slider.closest('.js-product-recommendation');
            const sectionID = productRecommendation.dataset.sectionId;
            const slides = slider.querySelectorAll('.js-product-recommendation__item');

            if (slides.length <= 4) {
              productRecommendation.classList.add('product-recommendation__swiper--center-desktop');
            }

            if (slides.length <= 1) {
              productRecommendation.classList.add('product-recommendation__swiper--center-mobile');
            }

            new Swiper(`.js-product-recommendation-swiper-${sectionID}`, {
              slidesPerView: 'auto',
              init: init,
              slidesOffsetBefore: slides.length <= 4 ? 0 : slidesOffsetBefore,
              freeMode: true,
              navigation: {
                nextEl: `.js-product-recommendation-button-next-${sectionID}`,
                prevEl: `.js-product-recommendation-button-prev-${sectionID}`,
                clickable: true
              },
              pagination: {
                el: `.js-product-recommendation-pagination-${sectionID}`,
                type: 'bullets'
              }
            });
          })
        }
      
        const breakpointChecker = () => {
          if (breakpoint.matches) {
            initSwiper(true, 0);
          } else {
            initSwiper(true);
          }
        };

        const scriptElement = document.createElement('script');
        scriptElement.src = productRecommendationsSection.dataset.productCardScript;
        scriptElement.setAttribute('defer', 'defer');
        document.body.appendChild(scriptElement);
      
        breakpoint.addEventListener('change', breakpointChecker);
        document.addEventListener("shopify:section:load", breakpointChecker);
        breakpointChecker();
      }
    });
})();
